































import { defineComponent, computed } from '@nuxtjs/composition-api';
import VueScrollTo from 'vue-scrollto';
import type { PropType } from '@nuxtjs/composition-api';
import ReviewsStars from '~/components/atoms/ReviewsStars.vue';
import { LinkType } from '~/types/components/Link/LinkType';
import { ProductRating } from '~/types/product/attribute/ProductReview';
import buildProductRating from '~/helpers/product/buildProductRating';
import { useAnchorNavigation } from '~/composables';

export default defineComponent({
  name: 'ProductAverageReview',
  components: {
    ReviewsStars,
    AggregateReviewSchema: () => import(/* webpackChunkName: "AggregateReviewSchema" */
      '~/components/molecules/Review/AggregateReviewSchema/AggregateReviewSchema.vue'),
  },
  props: {
    rating: {
      type: Object as PropType<ProductRating>,
      default: () => {
        return null;
      },
    },
    isCardReviews: {
      type: Boolean,
      default: false,
    },
    showSchema: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { stickyAnchorNavHeight } = useAnchorNavigation();
    // needed addidional px to enter section and make it active in intersector observer for anchor nav
    const additionalPxToEnterSection = 1;

    const scrollToReviews = () => {
      if (!props.isCardReviews) {
        VueScrollTo.scrollTo('#rating-reviews', {
          offset: -stickyAnchorNavHeight.value + additionalPxToEnterSection,
        });
      }
    };
    const ratingToShow = computed(() => {
      return buildProductRating({
        averageRating: props.rating?.averageRating,
        count: props.rating?.count,
        defaultTo0: true,
      });
    });
    return {
      ratingToShow,
      LinkType,
      scrollToReviews,
    };
  },
});
